import { useTheme, useBreakpoint } from '@hivebrite/design-system/Theme';

import type { RenderProps } from 'hb-builder/components/common/type/RenderProps';
import ResetStyledRoot from 'hb-builder/components/UIComponents/shared/common/Root/ResetStyledRoot';
import type { RenderComponent } from 'hb-builder/types';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { RootItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/rootItemAttributes';

const Root: RenderComponent = () => <div />; // never used

const DEFAULT_LINK_COLOR = '#4733FF';
const useLinkColorFromTheme = () => {
  const theme = useTheme();

  return theme.colors?.link || DEFAULT_LINK_COLOR;
};

const Render = ({
  children,
}: RenderProps<DocumentItem<RootItemAttributes>>) => {
  const linkColor = useLinkColorFromTheme();
  const breakpoint = useBreakpoint();

  return (
    <ResetStyledRoot
      data-testid="root-component"
      $breakpoint={breakpoint}
      $linkColor={linkColor}
      $unit="rem"
    >
      {children}
    </ResetStyledRoot>
  );
};

Root.componentName = 'Root';
Root.Render = Render;

export default Root;
